import { render } from "./AgeSelectRadio.vue?vue&type=template&id=2ebd39eb&scoped=true"
import script from "./AgeSelectRadio.vue?vue&type=script&lang=js"
export * from "./AgeSelectRadio.vue?vue&type=script&lang=js"

import "./AgeSelectRadio.vue?vue&type=style&index=0&id=2ebd39eb&scoped=true&lang=css"
import "./AgeSelectRadio.vue?vue&type=style&index=1&id=2ebd39eb&lang=css"

import exportComponent from "/Users/robertprikryl/smartAIm/unity_media/vue-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebd39eb"]])

export default __exports__